import React from 'react'
import { useHistory } from "react-router-dom";

function AdminHeader() {
    const history = useHistory();
    
    function logout(){
        localStorage.setItem("token","");
        console.log(" localStorage.setItem",localStorage.setItem("token",""))
        window.location.href = "/signin";
    }  
    const handleRoute = () =>{ 
        history.push("/admin/selfresetpassword/"+localStorage.getItem("userCode"));
    }
    return (
        <div>
            <nav class="sb-topnav navbar navbar-expand navbar-dark bg-dark">
                <a class="navbar-brand ps-3" href="#">Audit App</a>
                <button class="btn btn-link btn-sm order-1 order-lg-0 me-4 me-lg-0" id="sidebarToggle" href="#!"><i class="fas fa-bars"></i></button>
                {/* <form class="d-none d-md-inline-block form-inline ms-auto me-0 me-md-3 my-2 my-md-0">
                    <div class="input-group">
                        <input class="form-control" type="text" placeholder="Search for..." aria-label="Search for..." aria-describedby="btnNavbarSearch" />
                        <button class="btn btn-primary" id="btnNavbarSearch" type="button"><i class="fas fa-search"></i></button>
                    </div>
                </form>  */}
                {/* management and account
                  exeutive - attendance sheet */}
                <ul class="navbar-nav ms-auto ms-md-0 me-3 me-lg-4">
                    <li class="nav-item dropdown">
                        <a class="nav-link dropdown-toggle" id="navbarDropdown" href="#" role="button" data-bs-toggle="dropdown" aria-expanded="false"><i class="fas fa-user fa-fw"></i></a>
                        <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="navbarDropdown">
                           
                          
                            <li><a class="dropdown-item" onClick={() => logout()}>Logout</a></li>
                            <li><a class="dropdown-item" onClick={() => handleRoute()}>Reset Password</a></li>
                        </ul>
                    </li>
                </ul>
            </nav>
        </div>
    )
}



export default AdminHeader
